import React from 'react'
import PropTypes from 'prop-types'
import ContentLoader from 'react-content-loader'

export const EmailSkeleton = ({ speed, primaryColor, secondaryColor, height }) => (
  <div className='delivery-email-panel'>
    <ContentLoader
      viewBox={`0 0 100 ${height}`}
      speed={speed}
      backgroundColor={primaryColor}
      foregroundColor={secondaryColor}
    >
      <rect x='0' y='0' rx='0' ry='0' width='100' height={height} />
    </ContentLoader>
  </div>
)

EmailSkeleton.propTypes = {
  /**
   * Optional prop to affect the speed of the content loader
   */
  speed: PropTypes.number,
  /**
   * Optional prop to affect the background color
   */
  primaryColor: PropTypes.string,
  /**
   * Optional prop to affect the foreground color
   */
  secondaryColor: PropTypes.string,
  /**
   * Optional prop to affect the height
   */
  height: PropTypes.string
}

EmailSkeleton.defaultProps = {
  speed: 2,
  primaryColor: '#f0f0f0',
  secondaryColor: '#e5e5e5',
  height: '20'
}
